// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentOrdersStyles } from "@stoneage/Overrides/Widgets/Common/RecentOrders";
import { css } from "styled-components";
import { viewAllLinkStyle } from "@stoneage/App/SharedStyles/link";
import { xScreen } from "@stoneage/XDL/Utilities";

recentOrdersStyles.titleWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        margin-bottom: 16px;
        gap: 24px;
        ${xScreen("lte", "xs")} {
            gap: 10px;
            flex-wrap: wrap;
        }
    `,
};

recentOrdersStyles.tableWrapper = {
    css: css`
        width: 100%;
        overflow: auto;
    `,
};

recentOrdersStyles.titleLabel = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        text-transform: capitalize;
    `,
};

recentOrdersStyles.viewAllLink = {
    ...viewAllLinkStyle,
};

recentOrdersStyles.dataTable = {
    css: css`
        width: 100%;
        table-layout: fixed;
    `,
};
